import ModalHeader from 'components/Modal/ModalHeader';
import styles from './RedirectSuccess.module.scss';
import Modal from 'components/Modal/Modal';
import { useState } from 'react';
import Button from 'components/Button/Button';

const RedirectSuccess = ({ domain }) => {
    const queryParams = new URLSearchParams(window.location.search);
    const discord = queryParams.get('discord') === 'success';
    const [isOpen, setIsOpen] = useState(true);

    const handleModalClose = () => {
        const newUrl = window.location.origin + window.location.pathname;
        window.history.pushState({}, '', newUrl);
        setIsOpen(false);
    }

    if (!discord) {
        return null;
    }

    return (
        <Modal
            hasCrossButton
            domain={domain}
            className={styles.redirectSuccessModal}
            isOpen={isOpen}
            onClose={handleModalClose}
        >
            <ModalHeader
                title="Success!"
                description="Your WOWCube account has been successfully connected to Discord community!"
            />
            <Button
                onClick={handleModalClose}
                style={styles.redirectSuccessButton}
                primary
                wide
                community
                title="Done"
            />
        </Modal>
    );
}

export default RedirectSuccess;